import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import styles from "./SubNav.module.scss";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import subNavStyles from "./subNavStyles";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import MenuItem from "@mui/material/MenuItem";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import RegularDialog from "../Dialog/RegularDialog";
import { IS_NA_MARKET, GET_DEALER_NAME } from "../../utils/EmpUtil";

const SubNavDropdown = (props) => {
  const [open, setOpen] = useState(false);

  const dealerGroup =
    !IS_NA_MARKET(props.user.market) && props.user && props.user.dealerGroup;

  const getCurrentValue = () => {
    if (props.user.showAll) {
      return "All";
    }

    if (props.user && props.user.dealerGroup) {
      const currentDealer = props.user.dealerGroup.find(
        (dealer) => dealer.commonId === props.user.commonId
      );
      return currentDealer?.commonId;
    }

    return undefined;
  };

  const currentValue = getCurrentValue();
  const updateDealer = (event) => {
    let dealer;
    const showAll = event.target.value === "All";

    if (event.target.value === "DISABLED") {
      setOpen(true);
    } else if (showAll) {
      dealer = props.user.dealerGroup.filter(
        (dealer) => dealer.dealerType === "HUB" || dealer.dealerType === "MDLR"
      )[0];
      props.onDealerChanged(dealer, true);
    } else {
      dealer = props.user.dealerGroupingsMap[event.target.value];
      props.onDealerChanged(dealer);
    }
  };

  return (
    <div id="dropdown" className={styles.dropdownDiv}>
      <FormControl id="menu">
        <Select
          name="dropdown"
          id="select"
          data-testid="select"
          style={subNavStyles.dropdown}
          className={styles.dropdown}
          IconComponent={() => <KeyboardArrowDown style={subNavStyles.icon} />}
          value={currentValue}
          onChange={updateDealer}
        >
          <MenuItem style={subNavStyles.item} id="All" value="All" key="All">
            <p className={styles.dealerName}>{props.t("SubNav.all")}</p>
          </MenuItem>
          {dealerGroup &&
            dealerGroup.map((dealer) => {
              return (
                <MenuItem
                  style={subNavStyles.item}
                  id={dealer.commonId.split("|").join("")}
                  key={dealer.commonId.split("|").join("")}
                  value={dealer.commonId}
                >
                  <p
                    className={styles.unonboardedDealer}
                    id={dealer.commonId.split("|").join("")}
                  >
                    {!dealer.isOnboarded && (
                      <ReportProblemOutlinedIcon
                        className={styles.unonboardedDealerIcon}
                      />
                    )}
                    {GET_DEALER_NAME(dealer, props.user.market)} (
                    {dealer.completeDealerId})
                  </p>
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
      <RegularDialog
        open={open}
        close={() => setOpen(false)}
        icon={true}
        title={props.t("SubNav.disabledDealerTitle")}
        body={props.t("SubNav.disabledDealerBody")}
      />
    </div>
  );
};

export default withTranslation("emp")(SubNavDropdown);
